module.exports = __webpack_public_path__ + "static/media/010.bf5c2285.jpg";